<div class="poll-post-header">Updates</div>
<div class="poll-post-container">
  <div class="post-link-container">
    @if (user?.staff) {
      <a routerLink="/polls/{{ pollSlug }}/posts/new">Post an update</a>
    }
  </div>

  @for (post of posts; track post) {
    <div class="poll-post-item">
      <div class="status">
        <span class="poll-post-date">{{ (post.published_at || post.created_at) | date }}</span>
        @if (post.status === 'draft') {
          <tyt-tag>Draft</tyt-tag>
        }
        @if (post.hidden) {
          <tyt-tag>Hidden</tyt-tag>
        }
      </div>
      <tyt-expand-box [showReadLess]="true">
        <div class="cms-content" [innerHTML]="post.body | markdownToHtml | trustHtml"></div>
      </tyt-expand-box>
      @if (user?.staff) {
        <a routerLink="/polls/{{ pollSlug }}/posts/{{ post.id }}">Edit</a> |
        <a href="javascript:;" (click)="delete(post.id)">Delete</a>
      }
    </div>
  }
</div>